//# Settings Constants
export const SETTINGS_SET_COLOR_SCHEME = 'SETTINGS_SET_COLOR_SCHEME'
export const SETTINGS_SET_FONT_SIZE = 'SETTINGS_SET_FONT_SIZE'
